import { useQuery } from "@tanstack/react-query";
import { getMySubscription, type UserSubscriptionResponse } from "@/services/subscription";

export function useMySubscription(enabled = true) {
  return useQuery<UserSubscriptionResponse>({
    queryKey: ["my-subscription"],
    queryFn: getMySubscription,
    enabled,
    retry: false,           
    staleTime: 1000 * 60 * 5,
  });
}
